import { CategoryItem, Shop } from "~/use-cases/contracts/Shop";
import { useAppContext } from "../../app-context/provider";
import Link from "next/link";
import { Image } from "@crystallize/reactjs-components";
import React from "react";
import { buildLanguageMarketAwareLink } from "~/use-cases/LanguageAndMarket";

export const ProductCatSlider: React.FC<{
  categories: any[];
  lang: string;
}> = ({ categories, lang }) => {
  return (
    <div className="product-cat-slider">
      <div className="pcs__cats flex flex-row px-3 w-full lg:justify-center">
        {categories.map((category: any, index: number) => (
          <React.Fragment key={category.name + index}>
            {category.subMenu?.content?.value &&
              category.thumbnail?.content?.firstImage?.url && (
                <div className="pcs__cat">
                  <Link
                    href={buildLanguageMarketAwareLink(category.path, lang)}
                  >
                    <div className="pcs__image">
                      <Image
                        width={200}
                        height={90}
                        {...category.thumbnail?.content?.firstImage}
                        sizes="200px"
                        loading="eager"
                        alt={category.thumbnail?.altText}
                      />
                    </div>
                    <div className="pcs__title text-center font-bold text-xs">
                      {category.title ? category.title : category.name}
                    </div>
                  </Link>
                </div>
              )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
